import { getAuthToken } from '@/auth';
import { log } from '@/lib/utils';
import { postApiV1UserRefreshToken } from '@/open-api/user/user';

import type { Permission, Role } from '@/types/auth';
import type { NextIncomingMessage } from '@/types/request';

interface RefreshTokenResponse {
  aud: string;
  exp: string;
  iat: string;
  id: string;
  iss: string;
  nbf: string;
  permissions: Permission[] | Permission;
  role: Role[] | Role;
}

export const getAuthorizationToken = async ({
  req,
}: {
  req?: NextIncomingMessage;
} = {}): Promise<RefreshTokenResponse | null> => {
  const token = getAuthToken(req);

  log('Getting authorization token');

  if (token && token.length > 5) {
    const response = await postApiV1UserRefreshToken();

    log('Authorization token received');

    return response as RefreshTokenResponse | null;
  }

  log('No existing token found');

  return null;
};
